import React, { createContext, useContext, useState, ReactNode, useEffect, useCallback } from "react";
import { ActionItem } from "../models/SKArtifact";
import { ActionItem as ChannelActionItem } from "../models/SKChannel";
import { Location, useLocation } from "react-router-dom";
import { ActionOnItem, ActionItem as ApplicationActionItem } from "../models/SKApplication";

export interface NavigationProps {
  backArrow: boolean;
  title: string;
  buttonTitle: string;
  icon?: string;
  subtitle?: string;
  userActions?: string;
  enableLink: boolean;
  filterOption?: boolean;
  FilterButton?: React.ReactNode;
  onBack?: (() => void) | null;
  onSearch?: (() => void) | null;
  onClose?: (() => void) | null;
  onFilter?: (() => void) | null;
  onNext?: (() => void) | null;
  onEdit?: (() => void) | null;
  getActionItems?: () => ActionItem[] | ChannelActionItem[] | ApplicationActionItem[];
  onActionItemSelect?: (actionItem: string) => void;
  artifactStatus?: string;
}

interface NavigationContextProps {
  navProps: NavigationProps;
  setNavProps: React.Dispatch<React.SetStateAction<NavigationProps>>;
  unsavedChanges: boolean;
  setUnsavedChanges: React.Dispatch<React.SetStateAction<boolean>>;
  showChildRouteAsModal: (show: boolean) => void;
  backgroundLocation?: Location<any>;
  currentLocation: Location<any>;
}

const NavigationContext = createContext<NavigationContextProps | undefined>(undefined);

const defaultNavProps: NavigationProps = {
  backArrow: false,
  title: "",
  subtitle: "",
  enableLink: false,
  buttonTitle: "Next",
};

export const NavBarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [navProps, setNavProps] = useState<NavigationProps>(defaultNavProps);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [backgroundLocation, setBackgroundLocation] = useState<Location<any> | undefined>(undefined);
  const location = useLocation();
  const [showNavigation, setShowNavigation] = useState(true);

  useEffect(() => {
    console.log("Filter Button Object");
    console.log(navProps.FilterButton);
  }, [navProps]);

  const showChildRouteAsModal = useCallback(
    (show: boolean) => {
      show ? !backgroundLocation && setBackgroundLocation(location) : setBackgroundLocation(undefined);
    },
    [location]
  );

  return (
    <NavigationContext.Provider
      value={{
        navProps,
        setNavProps,
        unsavedChanges,
        setUnsavedChanges,
        showChildRouteAsModal,
        backgroundLocation,
        currentLocation: location,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigationBar = (): NavigationContextProps => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error("useNavigationBar must be used within a NavBarProvider");
  }
  return context;
};
